module.exports = __webpack_public_path__ + "static/media/header__company.5038bb53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/header__company.jpg
// module id = 682
// module chunks = 0